import { CylinderProperties } from './CylinderProperties';
import { updateShapeProperties } from '../action/actionCreators';

import { connect } from 'react-redux';

const mapStateToProps = function(items, id){
  return {
    item: items.itemList[id.id],
  };
};

const mapDispatchToProps = dispatch => ({
  updateShapeProperties: id => dispatch(updateShapeProperties(id)),
});

export default connect(
  mapStateToProps, 
  mapDispatchToProps
)(CylinderProperties);


// WEBPACK FOOTER //
// ./src/components/VisibleCylinderProperties.js